<template>
  <a-radio-group
    v-model:value="radioValue"
    style="width: 100%"
    @change="handleChange"
    :disabled="disabled"
  >
    <div v-for="(item, index) in data.optionsList" :key="index">
      <a-radio :style="radioStyle" :value="item.id ? item.id : item.optionContent"
        >{{ item.optionContent }}
      </a-radio>
      <a-input
        v-model:value="otherValue"
        v-if="item.othersFlag === '1' && otherInputValue"
        :placeholder="data.remind"
        @blur="handleChange"
        :maxlength="500"
        show-count
      />
    </div>
  </a-radio-group>
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: String,
    default: ''
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'change'])
const radioValue = ref(props.value)

const otherValue = ref('')

const otherInputValue = computed(() => {
  return props.data.optionsList.some(item => {
    if (item.id) {
      return item.id === radioValue.value && item.othersFlag === '1'
    } else {
      return item.optionContent === radioValue.value && item.othersFlag === '1'
    }
  })
})

const radioStyle = ref({
  display: 'flex',
  lineHeight: '32px'
})

// 暂定入参
const handleChange = () => {
  const str = {
    optionId: radioValue.value,
    otherContent: otherInputValue.value ? otherValue.value : '',
    othersFlag: otherInputValue.value ? '1' : undefined
  }
  emit('change', radioValue.value ? [str] : [])
}

onMounted(async () => {
  if (props.data.fieldValue) {
    radioValue.value = props.data.fieldValue[0].optionId
      ? props.data.fieldValue[0].optionId
      : undefined
    otherValue.value = props.data.fieldValue[0].otherContent
      ? props.data.fieldValue[0].otherContent
      : undefined
  }
})
</script>
